/*
  Everything in this file acts a dummy handler to replace the
  standard socket behavior. It will connect the socket, receive a reset
  then disconnect the socket and stop reconnects.

  The middleware doesn't do anything either.
*/

import io from 'socket.io-client'
import _ from 'lodash'

import {SOCKET_ROOM} from './socket.room'
import {SOCKET_AUTHENTICATE, SOCKET_LOAD_TRIP} from './socket.action'

let socket = null

export const localStorageMiddleware = (store) => (next) => (action) => {
    return next(action)
}

export const loadTripFromSocket = (host, store) => {
    socket = io(`${host}`)

    socket.on('connect', () => {
    // sends authenticate to server, we listen on authenticated room, then
    // if we get a response, we send up INITIALIZE_TRIP payload
        socket.emit(SOCKET_ROOM.AUTH, {
            type: SOCKET_AUTHENTICATE,
            travelerGuid: null
        })
    })

    socket.on(SOCKET_ROOM.AUTHENTICATED, () => {
        socket.emit(SOCKET_ROOM.PLANNER, {
            type: SOCKET_LOAD_TRIP,
            tripGuid: window.payload.trip.guid,
            itineraryGuid: window.payload.itinerary.guid,
            travelerGuid: null,
            name: null
        })
    })

    socket.on(SOCKET_ROOM.PLANNER, (data) => {
        if (data.type && data.type === 'RESET') {
            store.dispatch(data)
            socket.disconnect()
            socket = null
        }
    })
}
